// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/alcohol-drugs.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/alcohol-drugs/alcohol-drugs.js';
import g1 from '../lessons/air-law/alcohol-drugs/cannabis-policy.js';

mount([g0, g1]);
